import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      charts: "Charts",
      style_guide: "Style Guide",
      account: "Account",
      subscription: "Subscription",
      branding: "Your Style",
      subscribe_to_access_branding:
        "Subscribe to access your style customization",
      contact_us: "Contact us",
      log_out: "Log Out",
      subscription_page: {
        choose_your_plan: "Choose Your Plan",
        select_plan: "Select the plan that best fits your needs",
        manage_your_plan: "Manage Your Plan",
        current_plan: "You are currently subscribed to the Premium plan.",
        free: "Free",
        for_casual_users: "For casual users",
        price_free: "$0",
        per_month: "/month",
        create_chart_for_free: "Create a chart for free",
        max_charts_reached: "No more free charts available",
        recommended: "Recommended",
        your_current_plan: "Your current plan",
        manage_subscription: "Manage Your Subscription",
        select_free_plan: "Back to Free Plan",
        cancel_subscription: "Cancel Subscription",
        confirm_cancel_subscription:
          "Are you sure you want to cancel your subscription?",
        premium: "Premium",
        for_professionals: "For professionals",
        price_premium: "$6.00",
        upgrade_now: "Upgrade Now",
        need_help_choosing: "Need help choosing?",
        contact_support_text:
          "Contact our support team for assistance in selecting the right plan for your needs. We're here to help you make the most of our charting tools.",
        contact_support: "Contact Support",
        features: {
          unlimited_charts_office:
            "Unlimited charts on Office (PowerPoint, Excel, Word)",
          charts_saved_cloud: "Only 3 free charts",
          basic_export: "Basic export options",
          unlimited_charts_cloud: "Unlimited charts creation",
          advanced_export:
            "Advanced export in multiple formats, and no watermark",
          priority_support: "Premium support",
          custom_branding: "Custom branding",
        },
      },
      branding_page: {
        title: "Your Style",
        description:
          "No more repetitive setup. Your custom style is applied to every new chart automatically!",
        free_plan_description:
          "Tired of editing your colors every time? With <a>Premium</a>, just set your brand style once, and it's instantly applied to every new chart!",
        free_plan_subscribe_tooltip:
          "Subscribe to the Premium plan to use this feature.",
        bar_colors: "Bar colors",
        text_color: "Text color",
        background_color: "Background color",
        error_updating_theme:
          "Error updating your theme, please try again or contact support.",
        colors_title: "Colors",
        fonts_title: "Fonts",
        preview: "Preview",
        list_of_tasks: "List of tasks",
        timeline_content: "Timeline content",
      },
      not_found_page: {
        page_not_found: "404 - Page Not Found",
        page_not_found_description:
          "The page you are looking for doesn't exist or has been moved.",
        back_to_home: "Back to Home",
      },
      welcome_name: "Welcome {{name}} 👋",
      new_chart: "New Chart",
      delete: "Delete",
      duplicate: "Duplicate",
      edit: "Edit",
      logout: "Log Out",
      no_charts: "You don't have any charts yet.",
      an_error_occurred: "Oups, an error occurred...",
      chart_deleted: "Chart deleted.",
      chart_deletion_failed: "Chart deletion failed.",
      confirm_delete_title: "Are you sure you want to delete this chart?",
      confirm_delete_content: "This action cannot be undone.",
      yes: "Yes",
      no: "No",
      cancel: "Cancel",
      modal_duplicate_title: "Duplicate a Chart",
      modal_duplicate_content: "Please enter a title for the new chart.",
      chart_duplicated: "Chart duplicated.",
      chart_duplicated_failed: "Chart duplication failed.",
      new_chart_title: "New Chart title",
      copied_suffix: "copy",
      new_chart_title_required: "The new chart title is required",
      creation_date: "Creation date: {{createdAt}}",
      last_edition: "Last edition: {{updatedAt}}",
      edit_this_chart: "Edit this Chart",

      // Account related translations
      account_updated_successfully: "Account updated successfully",
      account_update_failed: "Account update failed",
      error_updating_profile: "Error updating profile",
      account_page_title: "Your information",
      account_email_title: "Your Email",
      connected_with_label:
        "You are connected with {{provider}} ({{email}}), you cannot edit your profile here.",
      login_method_windowslive: "Windows Live",
      "login_method_google-oauth2": "Google",
      account_name_label: "Name",
      account_first_name_label: "First Name",
      account_last_name_label: "Last Name",
      account_name_required: "Please enter your name",
      account_first_name_required: "Please enter your first name",
      account_last_name_required: "Please enter your last name",
      account_save_changes: "Save Changes",
      account_saving: "Saving...",
      account_email_label: "Email",
      account_error_updating_email: "Error updating your email",
      account_email_updated_successfully: "Email updated successfully",
      account_email_update_failed: "Email update failed",
      account_email_required: "Email is required",
      account_email_warning:
        "If you change your email, you will need to log in again.",
      footer: {
        brand_name: "Jane",
        copyright: "© {{year}}",
        legal_notice: "Legal Notice and Privacy Policy",
      },
      only_x_charts_left_zero: "You have no free charts left",
      only_x_charts_left_one: "You have only one free chart left",
      only_x_charts_left_other: "You have {{count}} free charts left",
      to_create_unlimited_charts:
        "To create unlimited charts, please subscribe to Jane.",
      subscribe_now: "Subscribe Now",
      share_page: {
        login_button: "Login to Jane",
        login_button_tooltip: "Log in to Jane to create timelines like this one.",
        cta_title: "Create your own timelines with Jane",
        cta_description: "Jane makes it easy to create beautiful, interactive timelines from your data. Sign up today and start visualizing your projects in minutes.",
        create_charts_button: "Create Your Own Timelines",
        legal_link: "Legal Notice",
        signup_link: "Sign Up",
        error_url_params: "Error parsing URL parameters",
        error_loading: "Error loading timeline",
        loading: "Loading timeline...",
        chart_not_found: "Timeline not found"
      },
    },
  },
  fr: {
    translation: {
      charts: "Graphiques",
      style_guide: "Guide de style",
      account: "Compte",
      subscription: "Abonnement",
      branding: "Votre style",
      subscribe_to_access_branding:
        "Abonnez-vous pour accéder à la personnalisation de votre style",
      contact_us: "Contactez-nous",
      log_out: "Se déconnecter",
      subscription_page: {
        choose_your_plan: "Choisissez votre forfait",
        select_plan:
          "Sélectionnez le forfait qui correspond le mieux à vos besoins",
        manage_your_plan: "Gérer votre forfait",
        current_plan: "Vous êtes actuellement abonné au forfait Premium.",
        free: "Gratuit",
        for_casual_users: "Pour les utilisateurs occasionnels",
        price_free: "0€",
        per_month: "/mois",
        create_chart_for_free: "Créer un graphique gratuitement",
        max_charts_reached: "Plus de graphs gratuits possibles",
        recommended: "Recommandé",
        your_current_plan: "Votre forfait actuel",
        manage_subscription: "Gérer votre abonnement",
        select_free_plan: "Retour au forfait gratuit",
        cancel_subscription: "Annuler votre abonnement",
        confirm_cancel_subscription:
          "Êtes-vous sûr de vouloir annuler votre abonnement ?",
        premium: "Premium",
        for_professionals: "Pour les professionnels",
        price_premium: "3,00€",
        upgrade_now: "Mettre à niveau maintenant",
        need_help_choosing: "Besoin d'aide pour choisir ?",
        contact_support_text:
          "Contactez notre équipe d'assistance pour vous aider à sélectionner le forfait adapté à vos besoins. Nous sommes là pour vous aider à tirer le meilleur parti de nos outils de création de graphiques.",
        contact_support: "Contacter le support",
        features: {
          unlimited_charts_office:
            "Graphiques illimités sur Office (PowerPoint, Excel, Word)",
          charts_saved_cloud: "Seulement 3 graphiques gratuits",
          basic_export: "Options d'exportation de base",
          unlimited_charts_cloud: "Graphiques illimités",
          advanced_export: "Exportation dans plusieurs formats",
          priority_support: "Support prioritaire",
          custom_branding: "Personnalisation graphique avancée",
        },
      },
      branding_page: {
        title: "Votre Style",
        description:
          "Fini les réglages répétitifs. Votre style personnalisé est automatiquement appliqué à chaque nouveau graphique !",
        free_plan_description:
          "Marre de devoir éditer vos couleurs à chaque fois ? Avec le <a>forfait premium</a>, définissez votre style de marque une fois, et il est instantanément appliqué à chaque nouveau graphique !",
        free_plan_subscribe_tooltip:
          "Abonnez-vous au forfait Premium pour utiliser cette fonctionnalité.",
        bar_colors: "Couleurs des barres",
        text_color: "Couleur du texte",
        background_color: "Couleur de fond",
        error_updating_theme:
          "Erreur lors de la mise à jour de votre thème, veuillez réessayer ou contacter le support.",
        colors_title: "Couleurs",
        fonts_title: "Polices",
        preview: "Aperçu",
        list_of_tasks: "Liste des tâches",
        timeline_content: "Chronologie",
      },
      not_found_page: {
        page_not_found: "404 - Page non trouvée",
        page_not_found_description:
          "La page que vous recherchez n'existe pas ou a été déplacée.",
        back_to_home: "Retour à l'accueil",
      },
      welcome_name: "Bienvenue {{name}} 👋",
      new_chart: "Nouveau graphique",
      delete: "Supprimer",
      duplicate: "Dupliquer",
      edit: "Éditer",
      logout: "Se déconnecter",
      no_charts: "Vous n'avez pas encore de graphiques.",
      an_error_occurred: "Oups, une erreur s'est produite...",
      chart_deleted: "Graphique supprimé.",
      chart_deletion_failed: "Échec de la suppression du graphique.",
      confirm_delete_title: "Êtes-vous sûr de vouloir supprimer ce graphique ?",
      confirm_delete_content: "Cette action ne peut pas être annulée.",
      yes: "Oui",
      no: "Non",
      cancel: "Annuler",
      modal_duplicate_title: "Dupliquer le graphique",
      modal_duplicate_content:
        "Veuillez entrer un titre pour le nouveau graphique.",
      chart_duplicated: "Graphique dupliqué.",
      chart_duplicated_failed: "Échec de la duplication du graphique.",
      new_chart_title: "Titre du nouveau graphique",
      copied_suffix: "copie",
      new_chart_title_required: "Le titre du nouveau graphique est requis",
      creation_date: "Date de création : {{createdAt}}",
      last_edition: "Dernière édition : {{updatedAt}}",
      edit_this_chart: "Éditer ce graphique",

      // Account related translations
      account_updated_successfully: "Compte mis à jour avec succès",
      account_update_failed: "Échec de la mise à jour du compte",
      account_page_title: "Vos informations",
      account_email_title: "Votre e-mail",
      error_updating_profile: "Erreur lors de la mise à jour du profil",
      connected_with_label:
        "Vous êtes connecté avec {{provider}} ({{email}}), vous ne pouvez pas modifier votre profil ici.",
      login_method_windowslive: "Windows Live",
      "login_method_google-oauth2": "Google",
      account_name_label: "Nom",
      account_first_name_label: "Prénom",
      account_last_name_label: "Nom de famille",
      account_name_required: "Veuillez entrer votre nom",
      account_first_name_required: "Veuillez entrer votre prénom",
      account_last_name_required: "Veuillez entrer votre nom de famille",
      account_save_changes: "Enregistrer les modifications",
      account_saving: "Enregistrement...",
      account_email_label: "E-mail",
      account_error_updating_email:
        "Erreur lors de la mise à jour de votre e-mail",
      account_email_updated_successfully: "E-mail mis à jour avec succès",
      account_email_update_failed: "Échec de la mise à jour de l'e-mail",
      account_email_required: "L'e-mail est requis",
      account_email_warning:
        "Si vous changez votre e-mail, vous devrez vous reconnecter.",
      footer: {
        brand_name: "Jane",
        copyright: "© {{year}}",
        legal_notice: "Mentions légales et politique de confidentialité",
      },
      only_x_charts_left_zero: "Vous n'avez plus de graphiques gratuits",
      only_x_charts_left_one: "Il ne vous reste qu'un seul graphique gratuit",
      only_x_charts_left_other:
        "Il ne vous reste plus que {{count}} graphiques gratuits",
      to_create_unlimited_charts:
        "Pour créer des graphiques illimités, veuillez vous abonner à Jane.",
      subscribe_now: "Abonnez-vous maintenant",
      share_page: {
        login_button: "Se connecter à Jane",
        login_button_tooltip: "Connectez-vous à Jane pour créer des timelines comme celle-ci.",
        cta_title: "Créez vos propres timelines avec Jane",
        cta_description: "Jane vous permet de créer facilement de belles timelines interactives à partir de vos données. Inscrivez-vous aujourd'hui et commencez à visualiser vos projets en quelques minutes.",
        create_charts_button: "Créez vos propres timelines",
        legal_link: "Mentions légales",
        signup_link: "S'inscrire",
        error_url_params: "Erreur lors de l'analyse des paramètres d'URL",
        error_loading: "Erreur lors du chargement de la timeline",
        loading: "Chargement de la timeline...",
        chart_not_found: "Timeline non trouvée"
      },
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
